import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "label", "className", "type", "iconKey", "defaultValue"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef } from 'react';
import BaseInput from './BaseInput';
import { jsx as _jsx } from "react/jsx-runtime";
var InputField = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var id = _ref.id,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? null : _ref$label,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    iconKey = _ref.iconKey,
    defaultValue = _ref.defaultValue,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(BaseInput, _objectSpread({
    id: id,
    ref: ref,
    label: label,
    className: className,
    type: type,
    iconKey: iconKey,
    defaultValue: defaultValue
  }, props));
});
export default InputField;